import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requireInvestorSession } from '@/features/investor-login/public';
import { Layout } from '@/features/portal-shell/public';

const TransactionsLayout = () => (
  <Layout>
    <Outlet />
  </Layout>
);

export const Route = createFileRoute('/transactions')({
  staticData: { navSection: 'transactions' },
  beforeLoad: () => requireInvestorSession(),
  component: TransactionsLayout,
});
